export default __webpack_public_path__ + "static/media/66-SidLee.45561a8e.jpg";